import React from 'react';
import { ONLINE_PROFILE_LINKS } from '../../data/companyProfiles';

const FindUsOnlineSection = () => (
  <div className="site-footer-online" aria-label="Find Us Online">
    <p className="site-footer-heading">Find Us Online</p>
    <div className="site-footer-online-links">
      {ONLINE_PROFILE_LINKS.map((profile) => (
        <a
          key={profile.label}
          href={profile.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={profile.ariaLabel}
          className="site-footer-online-link"
        >
          <span className="site-footer-online-label">{profile.label}</span>
          {profile.note ? (
            <span className="site-footer-online-note">{profile.note}</span>
          ) : null}
        </a>
      ))}
    </div>
  </div>
);

export default FindUsOnlineSection;
